import Link from 'next/link';
import { ActiveRoute } from '@/lib/helpers';
import { components_1, components_2, components_3 } from '@/lib/NavEntrys';

const MegaMenu2: React.FC = () => {
  return (
    <>
      <div className="container-fluid" id="megamenu">
        <div className="container-md px-0">
          <div className="row pb-5">
            <div className="col-12 pt-4">
              <h1 className="megamenu-heading">Häufig verwendete Elemente</h1>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              {components_1.map(([key, value]) => {
                return (
                  <Link href={value.link} key={key}>
                    <a className={ActiveRoute(value.link)} title={value.title}>
                      {value.title}
                    </a>
                  </Link>
                );
              })}
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              {components_2.map(([key, value]) => {
                return (
                  <Link href={value.link} key={key}>
                    <a className={ActiveRoute(value.link)} title={value.title}>
                      {value.title}
                    </a>
                  </Link>
                );
              })}
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              {components_3.map(([key, value]) => {
                return (
                  <Link href={value.link} key={key}>
                    <a className={ActiveRoute(value.link)} title={value.title}>
                      {value.title}
                    </a>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MegaMenu2;
